import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { LoaderService, ToastService } from '@mtgame/ui';
import { Game } from '@mtgame/core';
import { GameRootService } from '@core/services/game-root.service';

@Injectable()
export class TournamentGameResolver implements Resolve<Game> {
  constructor(
    private gameRootService: GameRootService,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private router: Router,
  ) {
  }
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    this.loaderService.show();
    try {
      return await this.gameRootService.initialize(route.params.gameId);
    } catch (e) {
      if (e.status === 404) {
        this.router.navigate(['/404'], {skipLocationChange: true, replaceUrl: false});
      } else {
        this.toastService.danger('Произошла ошибка');
        throw e;
      }
    } finally {
      this.loaderService.hide();
    }
  }
}
